import React from 'react';
import { Link } from 'gatsby';


function OurSpinOuts() {
  return (
    <article className="wrapper">
      <div className="container-fluid">
        <h1 className="font-weight-bolder underscore">Our Products<br />& Spin-outs</h1>
        <div className="row justify-content-center justify-content-lg-start">
          <div className="col-12 col-md-8 col-lg-6 d-flex align-items-stretch mb-5">
            <div className="pb-6 border-bottom">
              <div className="my-2 d-flex align-items-center">
                <span className="display-4 font-weight-bold">Artlimes.com</span>
                <span className="badge badge-pill badge-secondary ml-auto">Production</span>
              </div>
              <img src="/assets/what-we-do/artlimes.jpg" className="img-fluid" alt=" " />
              <div className="display-6 font-weight-bold my-3">PaaS, Marketplace, Art & Design, NFT</div>

              <div className="display-6 font-weight-light">
                <p>Artlimes.com is the most innovative and highly curated global marketplace for Art, Design & NFT Collectibles.</p>

                Artlimes connects the Art World with NFT. We are making online retail for physical and NFT collectibles easy for artists, galleries and luxury retailers.
              </div>

              <div className="text-right">
                <a
                  className="btn btn-primary mt-5 ml-auto"
                  href="https://artlimes.com"
                  target="_blank" rel="noreferrer"
                >
                  Visit website
                </a>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-8 col-lg-6 d-flex align-items-stretch mb-5">
            <div className="pb-6 border-bottom">
              <div className="my-2 d-flex align-items-center">
                <span className="display-4 font-weight-bold">Emurgence</span>
                <span className="badge badge-pill badge-secondary ml-auto">Production</span>
              </div>
              <img src="/assets/what-we-do/emurgence.jpg" className="img-fluid" alt="Emurgence" />
              <div className="display-6 font-weight-bold my-3">Healthcare, HealthTech, Wearables</div>
              <div className="display-6 font-weight-light">
                <p>24/7 real-time personal healthcare monitoring and support at home or outside.</p>

                Complete patient profiles with GPS and biometric data, offering patients remote healthcare assistance and monitoring by care teams, clinics, hospitals and organisations.
              </div>
              <div className="text-right">
                <a
                  className="btn btn-primary mt-5 ml-auto"
                  href="mailto:contact@emvelia.com?subject=Emurgence Request Demo"
                  target="_blank" rel="noreferrer"
                >
                  Request Demo
                </a>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-8 col-lg-6 d-flex align-items-stretch mb-5">
            <div className="pb-6 border-bottom">
              <div className="my-2 d-flex align-items-center">
                <span className="display-4 font-weight-bold">HydroSense & Hydro AI</span>
                <span className="badge badge-pill badge-secondary ml-auto">R&D stage</span>
              </div>
              <img src="/assets/what-we-do/hydrosense.jpg" className="img-fluid" alt=" " />
              <div className="display-6 font-weight-bold my-3">Maritime, Environmental, AI</div>
              <div className="display-6 font-weight-light">
                A state-of-the-art, eco-friendly, energy efficient and fully autonomous AI aquadrone, built to solve the ongoing problem of surface waste, microplastics and dirty waters in ports, marinas and the open sea.
              </div>
              {/* <div className="text-right">
                <a
                  className="btn btn-primary mt-5 ml-auto"
                  href="https://hydrosense.ai"
                  target="_blank"
                >
                  Visit website
                </a>
              </div> */}
            </div>
          </div>

          <div className="col-12 col-md-8 col-lg-6 d-flex align-items-stretch mb-5">
            <div className="pb-6 border-bottom">

              <div className="my-2 d-flex align-items-center">
                <span className="display-4 font-weight-bold">Preload.ai</span>
                <span className="badge badge-pill badge-secondary ml-auto">In progress</span>
              </div>
              <img src="/assets/what-we-do/preload.jpg" className="img-fluid" alt=" " />
              <div className="display-6 font-weight-bold my-3">SaaS, Search Engine Optimisation</div>
              <div className="display-6 font-weight-light">
                Real-time, Single Page Application (SPA) server-side rendering engine for search engines, bots and humans. A SaaS platform for optimising page speed rendering and increasing SEO performance.
              </div>
              {/* <div className="text-right">
                <a
                  className="btn btn-primary mt-5 ml-auto"
                  href="https://preload.ai"
                  target="_blank"
                >
                  Visit website
                </a>
              </div> */}
            </div>
          </div>
        </div>

        <h1 className="font-weight-bolder underscore">Client<br />Projects</h1>
        <div className="row justify-content-center justify-content-lg-start">
          <div className="col-12 col-md-8 col-lg-6 d-flex align-items-stretch mb-5">
            <div className="pb-6 border-bottom">
              <div className="my-2 d-flex align-items-center">
                <span className="display-4 font-weight-bold">Κ.Α.Ε.Β. (I.C.A.C.)</span>
                <span className="badge badge-pill badge-secondary ml-auto">Production</span>
              </div>
              <img src="/assets/what-we-do/icac.jpg" className="img-fluid" alt=" " />
              <div className="display-6 font-weight-bold my-3">HaaS & PaaS, Healthcare</div>
              <div className="display-6 font-weight-light">
                Funded by the Hellenic Ministry of Digital Governance, the Immediate Communication & Assistance Centre, also known in Greece as Κέντρο Άμεσης Επικοινωνίας & Βοηθείας (KAEB), is a state-of-the-art Hardware & Platform as a Service, implementing smart wearables and medical profiles to provide 24/7 Healthcare Support for Municipalities and their citizens.
              </div>

              <div className="text-right">
                <Link to="/case-studies/information-communication-assistance-center-kaeb" className="btn btn-primary mt-5 ml-auto">Read the Case Study</Link>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-8 col-lg-6 d-flex align-items-stretch mb-5">
            <div className="pb-6 border-bottom">
              <div className="my-2 d-flex align-items-center">
                <span className="display-4 font-weight-bold">DOME</span>
                <span className="badge badge-pill badge-secondary ml-auto">Early stage</span>
              </div>
              <img src="/assets/what-we-do/dome.jpg" className="img-fluid" alt=" " />
              <div className="display-6 font-weight-bold my-3">PaaS, Finance, AI</div>
              <div className="display-6 font-weight-light">
                A financing platform for new innovative businesses, connecting university students and alumni with angel investors and incubators.
              </div>
            </div>
          </div>

          <div className="col-12 col-md-8 col-lg-6 d-flex align-items-stretch mb-5">
            <div className="pb-6 border-bottom">
              <div className="my-2 d-flex align-items-center">
                <span className="display-4 font-weight-bold">Spatial Quotient</span>
                <span className="badge badge-pill badge-secondary ml-auto">Production</span>
              </div>
              <img src="/assets/what-we-do/spatial-quotient.jpg" className="img-fluid" alt=" " />
              <div className="display-6 font-weight-bold my-3">Healthcare, AI</div>
              <div className="display-6 font-weight-light">
                The solution has been deployed in hospitals in Denmark, Switzerland, Spain, Sweden, Italy, Turkey and the United Kingdom. It is a sensor-based positional system collecting real-time data used to analyse and optimise processes in healthcare using machine learning and other technologies.
              </div>
            </div>
          </div>


          <div className="col-12 col-md-8 col-lg-6 d-flex align-items-stretch mb-5">
            <div className="pb-6 border-bottom">
              <div className="my-2 d-flex align-items-center">
                <span className="display-4 font-weight-bold">Mumbli</span>
                <span className="badge badge-pill badge-secondary ml-auto">Production</span>
              </div>

              <img src="/assets/what-we-do/mumbli.jpg" className="img-fluid" alt=" " />
              <div className="display-6 font-weight-bold my-3">Hearing Wellness, Sound & Acoustics</div>
              <div className="display-6 font-weight-light">
                Mumbli enables people to be more productive and to be more connected through inclusive, attractive spaces that are grounded in innovative, accessible approaches to hearing wellness. We build IoT devices that connect people to spaces based on the live atmosphere, whilst giving businesses the ability to optimise and design their spaces for sound.
              </div>
            </div>
          </div>

          <div className="col-12 col-md-8 col-lg-6 d-flex align-items-stretch mb-5">
            <div className="pb-6 border-bottom">
              <div className="my-2 d-flex align-items-center">
                <span className="display-4 font-weight-bold">Atlas Copco </span>
                <span className="badge badge-pill badge-secondary ml-auto">Production</span>
              </div>
              <img src="/assets/what-we-do/atlas-copco.jpg" className="img-fluid" alt=" " />
              <div className="display-6 font-weight-bold my-3">Manufacturing</div>
              <div className="display-6 font-weight-light">
                The Optimizer 4.0 is a state-of-the-art energy efficient touch-screen and remote browser-based control center for managing compressors and processing vast amounts of real-time data through complex UIs.
              </div>
            </div>
          </div>

          <div className="col-12 col-md-8 col-lg-6 d-flex align-items-stretch mb-5">
            <div className="pb-6 border-bottom">
              <div className="my-2 d-flex align-items-center">
                <span className="display-4 font-weight-bold">Media Strom</span>
                <span className="badge badge-pill badge-secondary ml-auto">Production</span>
              </div>
              <img src="/assets/what-we-do/mediastrom.jpg" className="img-fluid" alt=" " />
              <div className="display-6 font-weight-bold my-3">Online Retail</div>
              <div className="display-6 font-weight-light">
                <p> With over 125 stores across Greece, Media Strom is the largest maker and retailer for mattresses. They create  sophisticated sleep systems that combine passion, experience, know-how, science and advanced technology.</p>
                We developed a complete multilingual online store experience that starts online and finishes in a store.
              </div>

              <div className="text-right">
                <a href="https://mediastrom.com" className="btn btn-primary mt-5 ml-auto" target="_blank" rel="noreferrer">Visit Site</a>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-8 col-lg-6 d-flex align-items-stretch mb-5">
            <div className="pb-6 border-bottom">
              <div className="my-2 d-flex align-items-center">
                <span className="display-4 font-weight-bold">Jmarketplace.io</span>
                <span className="badge badge-pill badge-secondary ml-auto">Production</span>
              </div>
              <img src="/assets/what-we-do/jmarketplace.jpg" className="img-fluid" alt=" " />
              <div className="display-6 font-weight-bold my-3">Marketplace Demo</div>
              <div className="display-6 font-weight-light">A fully responsive, functional, Reaction Commerce demo theme.</div>

              <div className="text-right">
                <a href="https://jmarketplace.io/" className="btn btn-primary mt-5 ml-auto" target="_blank" rel="noreferrer">Visit Site</a>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-8 col-lg-6 d-flex align-items-stretch mb-5">
            <div className="pb-6 border-bottom">
              <div className="my-2 d-flex align-items-center">
                <span className="display-4 font-weight-bold">Sea Ergon Marine</span>
                <span className="badge badge-pill badge-secondary ml-auto">Production</span>
              </div>
              <img src="/assets/what-we-do/seaergon.jpg" className="img-fluid" alt=" " />
              <div className="display-6 font-weight-bold my-3">Maritime</div>
              <div className="display-6 font-weight-light">
                <p>Sea Ergon is a key player in the fields of fire automation, navigation, intercommunication and shipbuilding sales for the marine market of Greece.</p>
                A complete Content Management System (CMS) built in Drupal.
              </div>

              <div className="text-right">
                <a href="http://seaergon.gr" className="btn btn-primary mt-5 ml-auto" target="_blank" rel="noreferrer">Visit Site</a>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-8 col-lg-6 d-flex align-items-stretch mb-5">
            <div className="pb-6 border-bottom">
              <div className="my-2 d-flex align-items-center">
                <span className="display-4 font-weight-bold">Love Jeans</span>
                <span className="badge badge-pill badge-secondary ml-auto">Production</span>
              </div>
              <img src="/assets/what-we-do/lovejeans.jpg" className="img-fluid" alt=" " />
              <div className="display-6 font-weight-bold my-3">Retail</div>
              <div className="display-6 font-weight-light">
                <p>love Jeans is a vibrant brand delivering up to the minute fashion for style-conscious women everywhere.</p>
                A custom website for LoveJeans, showcasing its online catalog and all retailers in the UK, Belgium and the Netherlands.
              </div>

              <div className="text-right">
                <a href="http://lovejeans.com" className="btn btn-primary mt-5 ml-auto" target="_blank" rel="noreferrer">Visit Site</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}

export default OurSpinOuts;
